import axiosInstance from "../axiosInstance";

const EMAILS = "/emails";

export const emails = data => axiosInstance.post(EMAILS, data);

export const customMethod = (id, request, method, data) => axiosInstance.post(EMAILS, data);